import { Spin } from 'antd';
import { useUnit } from 'effector-react';
import AnalyticsFilters from './AnalyticsFilters.jsx';
import AnalyticsCards from './AnalyticsCards.jsx';
import AnalyticsCharts from './AnalyticsCharts.jsx';
import {
  AnalyticsGate,
  getAnalyticsCompanyCountFx,
  getAnalyticsCountFx,
  getAnalyticsOkedFx,
  getAnalyticsRegionFx,
  getAnalyticsTaxCountFx,
  getAnalyticsTaxFx,
} from '../../../models/organizationsModel/index.js';

function OrganizationsAnalytics() {
  // const getAnalyticsCompanyCountLoading = useUnit(
  //   getAnalyticsCompanyCountFx.pending
  // );
  // const getAnalyticsTaxCountLoading = useUnit(getAnalyticsTaxCountFx.pending);
  const getAnalyticsCountLoading = useUnit(getAnalyticsCountFx.pending);
  const getAnalyticsOkedLoading = useUnit(getAnalyticsOkedFx.pending);
  const getAnalyticsRegionLoading = useUnit(getAnalyticsRegionFx.pending);
  const getAnalyticsTaxLoading = useUnit(getAnalyticsTaxFx.pending);

  const loading =
    getAnalyticsCountLoading ||
    getAnalyticsOkedLoading ||
    getAnalyticsRegionLoading ||
    getAnalyticsTaxLoading;

  console.log('loading', loading);

  return (
    <Spin spinning={loading}>
      <div>
        <AnalyticsGate />
        <AnalyticsFilters />
        <AnalyticsCards />
        <AnalyticsCharts />
      </div>
    </Spin>
  );
}

export default OrganizationsAnalytics;
